import { del, get, post } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getTestDefinitions = () => get(url.GET_TEST_DEFINITIONS)
export const addNewTestDefinition = testDefinition => post(url.ADD_NEW_TEST_DEFINITION, testDefinition)
export const updateTestDefinition = testDefinition => post(url.UPDATE_TEST_DEFINITION, testDefinition)
export const deleteTestDefinition = testDefinition => del(url.DELETE_TEST_DEFINITION, { headers: { testDefinition } })

